module.exports = __webpack_public_path__ + "static/media/select.ccd6ecec.svg";